import React from 'react';
import styled from 'styled-components';
import { 
  HomeIcon, 
  SearchIcon, 
  HeartIcon, 
  UserIcon,
  BookIcon
} from '@/components/icons';
import { useRouteMatch, useEnhancedNavigation } from '@/utils/router';
import { tabBarItems } from '@/config/routes';
import LiquidGlass from 'liquid-glass-react'
import { useLayoutContext } from '@/contexts/LayoutContext';

const TabItem = styled.button<{ $isActive: boolean }>`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  padding: ${({ theme }) => theme.spacing.xs} 1.0rem;
  background: none;
  border: none;
  cursor: pointer;
  color: ${({ theme, $isActive }) => 
    $isActive ? theme.colors.primary : theme.colors.text.secondary};
  position: relative;
  
  /* iOS原生触摸优化 */
  -webkit-tap-highlight-color: transparent;
  tap-highlight-color: transparent;
  touch-action: manipulation;
  user-select: none;
  -webkit-user-select: none;
`;

const TabIcon = styled.div<{ $isActive: boolean }>`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 3px; /* 调整图标和文本间距 */
  
  /* 确保Fluent Icons大小一致，移除可能导致闪烁的transition */
  svg {
    width: 24px !important;
    height: 24px !important;
    font-size: 24px !important;
  }
`;

const TabLabel = styled.span<{ $isActive: boolean }>`
  font-size: ${({ theme }) => theme.fontSizes.caption1};
  font-weight: ${({ theme, $isActive }) => 
    $isActive ? theme.fontWeights.medium : theme.fontWeights.regular};
  line-height: 1.1;
  
  /* iOS原生文本样式 */
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-rendering: optimizeLegibility;
  letter-spacing: -0.005em;
  
  /* 文本溢出处理 */
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 70px; /* 增加最大宽度 */
  text-align: center;
`;

// 图标映射
const iconMap = {
  Home: HomeIcon,
  Search: SearchIcon,
  Heart: HeartIcon,
  Info: UserIcon,
  Book: BookIcon
} as const;

const BottomTabBar: React.FC = () => {
  const { isExactMatch } = useRouteMatch();
  const { navigateTo } = useEnhancedNavigation();
  const { containerRef } = useLayoutContext();

  const handleTabClick = (path: string) => {
    navigateTo(path);
  };

  return (
    // <TabContainer>
    <LiquidGlass padding="2px 5px"
        style={{ position: 'fixed', top: '94%', left: '50%' }}
        mouseContainer={containerRef}
         >
      <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'center' }}>
      {tabBarItems.map((item) => {
        const isActive = isExactMatch(item.path);
        const IconComponent = iconMap[item.icon as keyof typeof iconMap];
        
        return (
          <TabItem
            key={item.path}
            $isActive={isActive}
            onClick={() => handleTabClick(item.path)}
            aria-label={`导航到${item.label}`}
          >            
            <TabIcon $isActive={isActive}>
              <IconComponent 
                size={24} 
                color={isActive ? 'currentColor' : 'currentColor'}
              />
            </TabIcon>
            
            <TabLabel $isActive={isActive}>
              {item.label}
            </TabLabel>
          </TabItem>
        );
      })}
      </div>
    </LiquidGlass>
    // </TabContainer>
  );
};

export default BottomTabBar;